import React, { forwardRef } from "react";

function AuthSetup(_, ref) {
  return (
    <>
      <iframe
        id="payer-auth-iframe"
        title="payer-auth-iframe"
        name="ddc-iframe"
        height="1"
        style={{ display: "none" }}
      />
      <form id="ddc-form" target="ddc-iframe" method="POST" action="" ref={ref.form}>
        <input id="JWT_ddc" type="hidden" name="JWT" value="" ref={ref.input}/>
      </form>
    </>
  );
}

export default forwardRef(AuthSetup);
